import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
  dark?: boolean;
}

export default function Breadcrumbs({ items, dark = false }: BreadcrumbsProps) {
  const base = dark ? 'text-background-200/70' : 'text-foreground-500';
  const linkClass = dark
    ? 'hover:text-accent-400 transition-colors whitespace-nowrap'
    : 'hover:text-primary-600 transition-colors whitespace-nowrap';
  const sepClass = dark ? 'text-background-50/30' : 'text-foreground-300';
  const lastClass = dark ? 'text-background-50 whitespace-nowrap' : 'text-foreground-800 whitespace-nowrap';

  return (
    <nav aria-label="面包屑导航" className={`flex items-center flex-wrap gap-2 text-xs md:text-sm ${base}`}>
      <Link to="/" className={linkClass}>
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className={`ri-arrow-right-s-line ${sepClass}`} />
          {item.to ? (
            <Link to={item.to} className={linkClass}>
              {item.label}
            </Link>
          ) : (
            <span className={lastClass}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}